import { Box } from '@chakra-ui/react';
import useFacultativeContainer from './FacultativeContainer';
import FacultativeTabTable from './views/FacultativeTabTable';
import FacultativeTabToolbar from './views/FacultativeTabToolbar';

const FacultativeTab = () => {
    const props = useFacultativeContainer();
    const { readonly } = props;

    return (
        <Box>
            {!readonly && <FacultativeTabToolbar {...props} />}
            <FacultativeTabTable {...props} />
        </Box>
    );
};

export default FacultativeTab;
